import { Injectable } from '@angular/core';
import { ConsultationUrl } from '../../../shared/urls/consultation.url';
import { BaseService } from '../../../shared/services/base.service';
import { Utility } from '../../../common/utility';
import { MedicalConditionCategoryUrl } from '../../../shared/urls/master-data.medical-condition-category.urls';
import { MedicalConditionUrl } from '../../../shared/urls/master-data.medical-condition.urls';
import { PatientUrl } from '../../../shared/urls/patient.url';

@Injectable()
export class MedicalConditionsService {
  constructor(private baseService: BaseService) {

  }

  getConsultationMedicalCondition(consultationId) {
    const url = Utility.stringFormat(ConsultationUrl.GET_CONSULTATION_MEDICAL_CONDITION, [consultationId]);
    return this.baseService.getData(url);
  }

  getPreviousMedicalConditions(patientId, consultationId, offset, limit) {
    const url = Utility.stringFormat(PatientUrl.GET_PREVIOUS_MEDICALCONDITION, [patientId, consultationId, offset, limit]);
    return this.baseService.getData(url);
  }

  getMedicalConditionCategories(gender) {
    return this.baseService.getData(MedicalConditionCategoryUrl.MEDICALCONDITIONCATEGORY_DROP_DOWN_LIST, { gender: gender });
  }

  getMedicalCondition(categoryId, patientId) {
    const url = MedicalConditionUrl.MEDICALCONDITION_CATEGORY.replace('{categoryId}', categoryId);
    return this.baseService.getData(url,{patientId:patientId});
  }

  updateMedicalCondition(consultationId, data, isMoveNextStep) {
    let url = ConsultationUrl.UPDATE_MEDICAL_CONDITION.replace('{consultationId}', consultationId);
    url += '?isMoveNextStep='+ isMoveNextStep;
    return this.baseService.postData(url, data);
  }
  quickSearchMedicalCondition(searchKey,patientId, showPinner = true) {
    return this.baseService.getData(MedicalConditionUrl.MEDICALCONDITION_SEARCH_BY_NAME, { searchKey: searchKey,patientId:patientId }, showPinner);
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/medical-conditions/medical-conditions.service.ts